import InfoBlock from 'components/UI/Blocks/InfoBlock'
import { Button } from 'components/UI/Buttons'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useAppSelector } from 'hooks'
import { useCreditDecision } from 'hooks/useCreditDecision'
import { useTranslation } from 'react-i18next'
import { propertySelector } from 'redux/store/slices/decisionSlice'
import tw from 'twin.macro'
import { numberWithSpaces } from 'utils'

const PledgeProgramHeader = () => {
  // Tools
  const { t } = useTranslation()

  // Selectors
  const property = useAppSelector(propertySelector)

  // Custom hooks
  const { selectedSubProgram, prepareSubView } = useCreditDecision()

  // Handlers
  const handleGoBack = () => {
    if (!selectedSubProgram) return
    prepareSubView(selectedSubProgram.id)
  }

  return (
    <InfoBlock>
      <Heading variant='subtitle' weight='bold'>
        {t('bank-offer')}
      </Heading>
      <Typography variant='subbody' twStyle={tw`mt-1 mb-4 text-grey-dark`}>
        {t('own-for-all-activity')}
      </Typography>
      <div tw='border border-primary-middle text-primary-middle bg-toggle-button p-4 rounded-[14px] text-center'>
        <Heading variant='subtitle'>
          до {numberWithSpaces(Number(property?.programs.credit_params.loan_amount).toFixed(0))} тг
        </Heading>
        <Typography variant='caption' twStyle={tw`text-grey-dark`}>
          {t('with-pledge')}
        </Typography>
      </div>
      <Button variant='text' twStyle={tw`p-0 w-[fit-content] mt-4`} onClick={handleGoBack}>
        <Typography variant='subbody' weight='bold' twStyle={tw`text-primary-middle cursor-pointer`}>
          {t('flow-change-condition')}
        </Typography>
      </Button>
    </InfoBlock>
  )
}

export default PledgeProgramHeader
